var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient"},_vm._l((_vm.colorList),function(color){return _c('div',{key:color,staticClass:"grad-step",style:(_vm.getStyle(color))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }